module.exports = __webpack_public_path__ + "1cde6d2127de36ff8f9628995b7a4d8c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/book-shelf-s.png
// module id = 1856
// module chunks = 0